/**
 *
 * InProgressTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.amethystDark};
    background: ${COLORS.amethystLight};
    border-color: ${COLORS.amethyst};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.amethyst};
    }
  }
`;

function InProgressTag(props) {
  return <StyledTag label="In Progress" icon={<PinTripIcon />} {...props} />;
}

export default memo(InProgressTag);
